import { render, staticRenderFns } from "./CartContent.vue?vue&type=template&id=47f04028&scoped=true"
import script from "./CartContent.vue?vue&type=script&lang=ts"
export * from "./CartContent.vue?vue&type=script&lang=ts"
import style0 from "./CartContent.vue?vue&type=style&index=0&id=47f04028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f04028",
  null
  
)

export default component.exports